import { UilApps, UilFileAlt, UilCheckSquare, UilListUl, UilArrowUpRight } from '@iconscout/react-unicons';
import { Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';

function MenuItems({ toggleCollapsed }) {
    const { t } = useTranslation();

    function getItem(label, key, icon, children, type) {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    }

    const { topMenu } = useSelector((state) => {
        return {
            topMenu: state.ChangeLayoutMode.topMenu,
        };
    });

    const path = '/employee';

    const pathName = window.location.pathname;
    const pathArray = pathName.split(path);
    const mainPath = pathArray[1];
    const mainPathSplit = mainPath.split('/');

    const [openKeys, setOpenKeys] = React.useState(
        !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
    );

    const onOpenChange = (keys) => {
        setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
    };

    const onClick = (item) => {
        if (item.keyPath.length === 1) setOpenKeys([]);
    };

    const items = [
        // getItem(
        //     <NavLink onClick={toggleCollapsed} to={`${path}/projects`}>
        //         {t('Projects')}
        //     </NavLink>,
        //     'Projects', !topMenu && <UilApps />,
        //     null
        // ),
        // getItem(
        //     <NavLink onClick={toggleCollapsed} to={`${path}/task-manager`}>
        //         {t('Task Manager')}
        //     </NavLink>,
        //     'Task Manager', !topMenu && <UilFileAlt />,
        //     null
        // ),
        getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/mytasks`}>
                {t('My Tasks')}
            </NavLink>,
            'My Tasks', !topMenu && <UilListUl />,
            null
        ),
        // getItem(
        //     <NavLink onClick={toggleCollapsed} to={`${path}/requirements`}>
        //         {t('Requirements')}
        //     </NavLink>,
        //     'Requirements', !topMenu && <UilArrowUpRight />,
        //     null
        // ),
        getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/todo`}>
                {t('Todo')}
            </NavLink>,
            'Todo', !topMenu && <UilCheckSquare />,
            null
        ),
        getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/statusreport`}>
                {t('Status Report')}
            </NavLink>,
            'status report', !topMenu && <UilCheckSquare />,
            null
        ),
        getItem(
            <NavLink onClick={toggleCollapsed} to={`${path}/leave`}>
                {t('Leaves')}
            </NavLink>,
            'leaves', !topMenu && <UilCheckSquare />,
            null
        ),
    ];

    return (
        <Menu
            onOpenChange={onOpenChange}
            onClick={onClick}
            mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
            // // eslint-disable-next-line no-nested-ternary
            defaultSelectedKeys={
                !topMenu
                    ? [
                        `${mainPathSplit.length === 1 ? 'dashboard' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
                        }`,
                    ]
                    : []
            }
            defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
            overflowedIndicator={<UilEllipsisV />}
            openKeys={openKeys}
            items={items}
        />
    );
}

MenuItems.propTypes = {
    toggleCollapsed: propTypes.func,
};

export default MenuItems;
